import { render, staticRenderFns } from "./ServerDown.vue?vue&type=template&id=02134ae8&scoped=true&"
import script from "./ServerDown.vue?vue&type=script&lang=js&"
export * from "./ServerDown.vue?vue&type=script&lang=js&"
import style0 from "./ServerDown.vue?vue&type=style&index=0&id=02134ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02134ae8",
  null
  
)

export default component.exports